__webpack_require__.p = "/projets/calcul-trainer2/";